import getConfig from 'next/config';

import { ImageCDNProvider } from '../../../@packages/common';
import { CLOUDINARY_BASE_URL } from '../../../constants/cloudinary';
import type { DyImage } from '../types';
import { dyImageSrcToCloudinaryImageSrc } from '../utils/dyImageSrcToCloudinaryImageSrc';

const { publicRuntimeConfig } = getConfig();
const { ASSETS_URL } = publicRuntimeConfig;

export function dyImageSrcToCdnImageSrc(
  image: DyImage,
  cdnProvider: ImageCDNProvider,
  format = 'auto',
  quality = 75,
  dpr = 1,
): string {
  const assetsUrl = new URL(ASSETS_URL);

  switch (cdnProvider) {
    case 'cloudflare':
      return `//${assetsUrl.host}/cdn-cgi/image/w=${image.width},h=${image.height},format=${format},q=${quality},dpr=${dpr}/${image.src}`;
    case 'cloudinary':
      return `${CLOUDINARY_BASE_URL}/w_${image.width},h_${
        image.height
      },q_auto,f_auto,dpr_auto/${dyImageSrcToCloudinaryImageSrc(image.src)}`;
    default:
      image.src;
  }
}
